import { AlertTriangle, WifiOff, FileQuestion, RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"
import { AxiosError } from "axios"
import { InlineErrorProps } from "../contrato.types"

function getErrorDetails(error: unknown, entityName: string, entityId?: string | number) {
  const axiosError = error as AxiosError

  if (axiosError?.response?.status === 404) {
    return {
      icon: <FileQuestion className="w-8 h-8 text-gray-400" />,
      title: "Não encontrado",
      message: entityId
        ? `${entityName} com ID ${entityId} não encontrado no banco de dados`
        : `${entityName} não encontrado`,
      tips: [
        "Certifique-se de que um projeto esteja selecionado no menu superior",
        "Crie um projeto no sistema (se ainda não existe)",
        `Ou verifique se o ${entityName.toLowerCase()} existe`
      ]
    }
  }

  if (axiosError?.message === "Network Error") {
    return {
      icon: <WifiOff className="w-8 h-8 text-yellow-500" />,
      title: "Erro de conexão",
      message: "Backend não está acessível. Verifique se está rodando.",
      tips: [
        "Verifique sua conexão com a internet",
        "Confirme se o servidor backend está em execução",
        "Tente novamente em alguns instantes"
      ]
    }
  }

  return {
    icon: <AlertTriangle className="w-8 h-8 text-red-500" />,
    title: "Erro ao carregar",
    message: axiosError?.message || "Erro ao comunicar com o servidor",
    tips: [
      "Tente recarregar a página",
      "Verifique sua conexão",
      "Se o problema persistir, contate o suporte"
    ]
  }
}

export function InlineError({
  error,
  entityName = "Recurso",
  entityId,
  onRetry,
  showTips = true
}: InlineErrorProps) {
  const errorDetails = getErrorDetails(error, entityName, entityId)

  return (
    <div className="text-center py-12">
      <div className="flex justify-center mb-4">
        {errorDetails.icon}
      </div>
      <p className="text-red-500 font-medium mb-2">{errorDetails.title}</p>
      <p className="text-gray-400 text-sm mb-4">{errorDetails.message}</p>

      {showTips && errorDetails.tips && (
        <div className="text-left max-w-md mx-auto bg-gray-800/50 rounded-lg p-4 mb-4">
          <p className="text-sm text-gray-300 mb-2 font-semibold">Para resolver:</p>
          <ol className="text-xs text-gray-400 space-y-1 list-decimal list-inside">
            {errorDetails.tips.map((tip, index) => (
              <li key={index}>{tip}</li>
            ))}
          </ol>
        </div>
      )}

      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          <RefreshCw className="w-4 h-4 mr-2" />
          Tentar novamente
        </Button>
      )}
    </div>
  )
}
